import { gql } from '@apollo/client'
import { AUDIT_QUESTION_FRAGMENT } from '../fragments'

export const GET_AUDIT_QUESTIONS = gql`
  query GetAuditQuestions {
    auditQuestions {
      ...AuditQuestion
    }
  }
  ${AUDIT_QUESTION_FRAGMENT}
`
